export default __webpack_public_path__ + "static/media/WaterBg.78b3c335.png";